var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"10","y":"10","width":"70","height":"70","style":{"fill":"none","stroke":"#eee","strokeWidth":"1","opacity":"0.2","vectorEffect":"non-scaling-stroke"},"key":0}),React.createElement("polygon",{"points":"20 74 0 74 10 89.85 20 74","style":{"fill":"#eee","opacity":"0.2"},"key":1}),React.createElement("rect",{"width":"90","height":"90","style":{"fill":"none"},"key":2})]);
}

Icon.defaultProps = {"viewBox":"0 0 90 90"};

module.exports = Icon;

Icon.default = Icon;
